import { render, staticRenderFns } from "./NoticeOther.vue?vue&type=template&id=ac4526d6&scoped=true&"
import script from "./NoticeOther.vue?vue&type=script&lang=js&"
export * from "./NoticeOther.vue?vue&type=script&lang=js&"
import style0 from "./NoticeOther.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NoticeOther.vue?vue&type=style&index=1&id=ac4526d6&lang=less&scoped=true&"
import style2 from "./NoticeOther.vue?vue&type=style&index=2&id=ac4526d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4526d6",
  null
  
)

export default component.exports